var map = {
	"./Anhui-power.png": "ebe0",
	"./Beijing-power.png": "a996",
	"./Chongqing-power.png": "8a1e",
	"./Fujian-power.png": "dfff",
	"./Gansu-power.png": "9b7b",
	"./Guangdong-power.png": "5d34",
	"./Guangxi-power.png": "85b6",
	"./Guizhou-power.png": "83f2",
	"./Hainan-power.png": "286a",
	"./Hebei-power.png": "fa54",
	"./Heilongjiang-power.png": "dd60",
	"./Henan-power.png": "0aab",
	"./Hubei-power.png": "c9eb",
	"./Hunan-power.png": "cf14",
	"./Jiangsu-power.png": "b01a",
	"./Jiangxi-power.png": "d0e9",
	"./Jinlin-power.png": "5ce6",
	"./Liaoning-power.png": "1345",
	"./Nei Mongol-power.png": "bebb",
	"./Ningxia Hui-power.png": "b246",
	"./Qinghai-power.png": "87cb",
	"./Shaanxi-power.png": "eee8",
	"./Shandong-power.png": "0c01",
	"./Shanghai-power.png": "b7e1",
	"./Shanxi-power.png": "f6a1",
	"./Sichuan-power.png": "49df",
	"./Tianjin-power.png": "96eb",
	"./Xinjiang Uygur-power.png": "08f2",
	"./Xizang-power.png": "4755",
	"./Yunnan-power.png": "8c9f",
	"./Zhejiang-power.png": "89d9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4c11";